import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-be86caa8"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["aria-label"];
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "rope-track",
  "aria-hidden": "true"
}, null, -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "rope-fill",
  "aria-hidden": "true"
}, null, -1));
import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from "vue";
import { Top } from "@element-plus/icons-vue";
import { useRoute } from "vue-router";
export default {
  __name: 'PageScrollRope',
  setup(__props) {
    const route = useRoute();
    const progress = ref(0);
    const scrollable = ref(false);
    const isStudioRoute = computed(() => ["writeArticle", "editArticleById"].includes(route.name));
    let frameId = 0;
    let resizeObserver = null;
    let pointer = null;
    let suppressClick = false;
    let previousScrollBehavior = "";
    const dragging = ref(false);
    const startDrag = event => {
      if (!event.isPrimary || event.button !== 0) return;
      suppressClick = false;
      pointer = {
        id: event.pointerId,
        y: event.clientY,
        progress: progress.value,
        height: event.currentTarget.getBoundingClientRect().height,
        target: event.currentTarget
      };
      event.currentTarget.setPointerCapture(event.pointerId);
    };
    const moveDrag = event => {
      if (!pointer || pointer.id !== event.pointerId) return;
      const delta = event.clientY - pointer.y;
      if (!dragging.value && Math.abs(delta) < 5) return;
      if (!dragging.value) {
        previousScrollBehavior = document.documentElement.style.scrollBehavior;
        document.documentElement.style.scrollBehavior = "auto";
        dragging.value = true;
        suppressClick = true;
      }
      const ratio = Math.min(1, Math.max(0, pointer.progress / 100 + delta / Math.max(1, pointer.height)));
      const range = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      window.scrollTo({
        top: ratio * range,
        behavior: "auto"
      });
      scheduleUpdate();
    };
    const endDrag = () => {
      const active = pointer;
      pointer = null;
      if (dragging.value) document.documentElement.style.scrollBehavior = previousScrollBehavior;
      dragging.value = false;
      if (active?.target.hasPointerCapture(active.id)) active.target.releasePointerCapture(active.id);
    };
    const handleClick = event => {
      if (suppressClick && event.detail !== 0) {
        suppressClick = false;
        return;
      }
      scrollToTop();
    };
    const updateProgress = () => {
      frameId = 0;
      const root = document.documentElement;
      const scrollRange = Math.max(0, root.scrollHeight - window.innerHeight);
      scrollable.value = scrollRange > 24;
      progress.value = scrollRange ? Math.min(100, Math.max(0, window.scrollY / scrollRange * 100)) : 0;
    };
    const scheduleUpdate = () => {
      if (frameId) return;
      frameId = window.requestAnimationFrame(updateProgress);
    };
    const scrollToTop = () => {
      const reducedMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
      window.scrollTo({
        top: 0,
        behavior: reducedMotion ? "auto" : "smooth"
      });
    };
    watch(() => route.fullPath, async () => {
      endDrag();
      await nextTick();
      scheduleUpdate();
    });
    onMounted(() => {
      window.addEventListener("scroll", scheduleUpdate, {
        passive: true
      });
      window.addEventListener("resize", scheduleUpdate, {
        passive: true
      });
      if (window.ResizeObserver) {
        resizeObserver = new ResizeObserver(scheduleUpdate);
        resizeObserver.observe(document.documentElement);
        if (document.body) resizeObserver.observe(document.body);
      }
      scheduleUpdate();
    });
    onBeforeUnmount(() => {
      endDrag();
      window.removeEventListener("scroll", scheduleUpdate);
      window.removeEventListener("resize", scheduleUpdate);
      resizeObserver?.disconnect();
      if (frameId) window.cancelAnimationFrame(frameId);
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      return _withDirectives((_openBlock(), _createElementBlock("button", {
        type: "button",
        class: _normalizeClass(["page-scroll-rope", {
          'studio-scroll-rope': isStudioRoute.value,
          'is-dragging': dragging.value
        }]),
        style: _normalizeStyle({
          '--rope-progress': `${progress.value}%`
        }),
        "aria-label": `当前页面进度 ${Math.round(progress.value)}%，单击返回顶部，可上下拖动滚动页面`,
        onPointerdown: startDrag,
        onPointermove: moveDrag,
        onPointerup: endDrag,
        onPointercancel: endDrag,
        onLostpointercapture: endDrag,
        onClick: handleClick
      }, [_hoisted_2, _hoisted_3, _createElementVNode("span", {
        class: "rope-knot",
        style: _normalizeStyle({
          top: `${progress.value}%`
        }),
        "aria-hidden": "true"
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(Top))]),
        _: 1
      })], 4), _createElementVNode("span", {
        class: "rope-tip",
        style: _normalizeStyle({
          top: `${Math.min(96, Math.max(4, progress.value))}%`
        }),
        "aria-hidden": "true"
      }, _toDisplayString(dragging.value ? `已浏览 ${Math.round(progress.value)}%` : '单击返回顶部 · 上下拖动'), 5)], 46, _hoisted_1)), [[_vShow, scrollable.value]]);
    };
  }
};